// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-InfoPanels-module__infoPanels-wfUZO {
  position: relative;
  background-color: var(--background-secondary);
  width: 100%;
}

.nightbot-InfoPanels-module__infoPanelsContainer-LrqMm {
  padding: 0px 16px;
}

.nightbot-InfoPanels-module__infoPanelsGrid-LpO5r {
  gap: 32px;
}

.nightbot-InfoPanels-module__title-qJiTd {
  font-size: 32px;
  margin-bottom: 16px;
  text-align: center;
  justify-self: center;
}

.nightbot-InfoPanels-module__description-Kprjg {
  max-width: 600px;
  margin-bottom: 64px;
  text-align: center;
  justify-self: center;
}

.nightbot-InfoPanels-module__infoPanel-Mfzzt {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  border-radius: var(--mantine-radius-xl);
}

.nightbot-InfoPanels-module__infoPanelAvatar-ejR0G {
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
  border-radius: var(--mantine-radius-xl);
  --avatar-bg: transparent;
}

@supports ((-webkit-mask-image: paint(squircle)) or (mask-image: paint(squircle))) {

.nightbot-InfoPanels-module__infoPanelAvatar-ejR0G {
    --squircle-smooth: 1;
    --squircle-radius: 96px;
    -webkit-mask-image: paint(squircle);
            mask-image: paint(squircle);
}
  }

.nightbot-InfoPanels-module__avatarColorPink-UW86O {
  background: linear-gradient(to bottom right, var(--mantine-color-pink-4), var(--mantine-color-pink-5));
  color: var(--mantine-color-pink-1);
}

.nightbot-InfoPanels-module__avatarColorPurple-QFWAk {
  background: linear-gradient(to bottom right, var(--mantine-color-purple-4), var(--mantine-color-purple-5));
  color: var(--mantine-color-purple-1);
}

.nightbot-InfoPanels-module__avatarColorGreen-k83hn {
  background: linear-gradient(to bottom right, var(--mantine-color-green-4), var(--mantine-color-green-5));
  color: var(--mantine-color-green-1);
}

.nightbot-InfoPanels-module__avatarColorRed-k_2RK {
  background: linear-gradient(to bottom right, var(--mantine-color-red-4), var(--mantine-color-red-5));
  color: var(--mantine-color-red-1);
}

.nightbot-InfoPanels-module__avatarColorIndigo-cnAIx {
  background: linear-gradient(to bottom right, var(--mantine-color-indigo-4), var(--mantine-color-indigo-5));
  color: var(--mantine-color-indigo-1);
}

.nightbot-InfoPanels-module__avatarColorOrange-Zx0fo {
  background: linear-gradient(to bottom right, var(--mantine-color-orange-4), var(--mantine-color-orange-5));
  color: var(--mantine-color-orange-1);
}

.nightbot-InfoPanels-module__infoPanelLink-Oy2jq {
  width: -moz-fit-content;
  width: fit-content;
}

.nightbot-InfoPanels-module__infoPanelAvatarIcon-egHUa {
  width: 24px;
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/landing/InfoPanels.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,wBAAwB;AAO1B;;AALE;;AAPF;IAQI,oBAAoB;IACpB,uBAAuB;IACvB,mCAA2B;YAA3B,2BAA2B;AAE/B;EADE;;AAGF;EACE,sGAAsG;EACtG,kCAAkC;AACpC;;AAEA;EACE,0GAA0G;EAC1G,oCAAoC;AACtC;;AAEA;EACE,wGAAwG;EACxG,mCAAmC;AACrC;;AAEA;EACE,oGAAoG;EACpG,iCAAiC;AACnC;;AAEA;EACE,0GAA0G;EAC1G,oCAAoC;AACtC;;AAEA;EACE,0GAA0G;EAC1G,oCAAoC;AACtC;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".infoPanels {\n  position: relative;\n  background-color: var(--background-secondary);\n  width: 100%;\n}\n\n.infoPanelsContainer {\n  padding: 0px 16px;\n}\n\n.infoPanelsGrid {\n  gap: 32px;\n}\n\n.title {\n  font-size: 32px;\n  margin-bottom: 16px;\n  text-align: center;\n  justify-self: center;\n}\n\n.description {\n  max-width: 600px;\n  margin-bottom: 64px;\n  text-align: center;\n  justify-self: center;\n}\n\n.infoPanel {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 24px;\n  border-radius: var(--mantine-radius-xl);\n}\n\n.infoPanelAvatar {\n  width: 48px;\n  height: 48px;\n  margin-bottom: 16px;\n  border-radius: var(--mantine-radius-xl);\n  --avatar-bg: transparent;\n  \n  @supports (mask-image: paint(squircle)) {\n    --squircle-smooth: 1;\n    --squircle-radius: 96px;\n    mask-image: paint(squircle);\n  }\n}\n\n.avatarColorPink {\n  background: linear-gradient(to bottom right, var(--mantine-color-pink-4), var(--mantine-color-pink-5));\n  color: var(--mantine-color-pink-1);\n}\n\n.avatarColorPurple {\n  background: linear-gradient(to bottom right, var(--mantine-color-purple-4), var(--mantine-color-purple-5));\n  color: var(--mantine-color-purple-1);\n}\n\n.avatarColorGreen {\n  background: linear-gradient(to bottom right, var(--mantine-color-green-4), var(--mantine-color-green-5));\n  color: var(--mantine-color-green-1);\n}\n\n.avatarColorRed {\n  background: linear-gradient(to bottom right, var(--mantine-color-red-4), var(--mantine-color-red-5));\n  color: var(--mantine-color-red-1);\n}\n\n.avatarColorIndigo {\n  background: linear-gradient(to bottom right, var(--mantine-color-indigo-4), var(--mantine-color-indigo-5));\n  color: var(--mantine-color-indigo-1);\n}\n\n.avatarColorOrange {\n  background: linear-gradient(to bottom right, var(--mantine-color-orange-4), var(--mantine-color-orange-5));\n  color: var(--mantine-color-orange-1);\n}\n\n.infoPanelLink {\n  width: fit-content;\n}\n\n.infoPanelAvatarIcon {\n  width: 24px;\n  height: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoPanels": `nightbot-InfoPanels-module__infoPanels-wfUZO`,
	"infoPanelsContainer": `nightbot-InfoPanels-module__infoPanelsContainer-LrqMm`,
	"infoPanelsGrid": `nightbot-InfoPanels-module__infoPanelsGrid-LpO5r`,
	"title": `nightbot-InfoPanels-module__title-qJiTd`,
	"description": `nightbot-InfoPanels-module__description-Kprjg`,
	"infoPanel": `nightbot-InfoPanels-module__infoPanel-Mfzzt`,
	"infoPanelAvatar": `nightbot-InfoPanels-module__infoPanelAvatar-ejR0G`,
	"avatarColorPink": `nightbot-InfoPanels-module__avatarColorPink-UW86O`,
	"avatarColorPurple": `nightbot-InfoPanels-module__avatarColorPurple-QFWAk`,
	"avatarColorGreen": `nightbot-InfoPanels-module__avatarColorGreen-k83hn`,
	"avatarColorRed": `nightbot-InfoPanels-module__avatarColorRed-k_2RK`,
	"avatarColorIndigo": `nightbot-InfoPanels-module__avatarColorIndigo-cnAIx`,
	"avatarColorOrange": `nightbot-InfoPanels-module__avatarColorOrange-Zx0fo`,
	"infoPanelLink": `nightbot-InfoPanels-module__infoPanelLink-Oy2jq`,
	"infoPanelAvatarIcon": `nightbot-InfoPanels-module__infoPanelAvatarIcon-egHUa`
};
export default ___CSS_LOADER_EXPORT___;
